import React, { useState, useEffect } from "react";
import { Box, Card, Typography } from "@mui/material";
import { selectSelectedConnection } from "@/features/connections/integrationSlice";
import { useDispatch, useSelector } from "react-redux";
import axios from "@/features/axiosHelper";
import Dropdown from "@/components/Dropdown/Dropdown";
import EmailSchemaSettings from "@/components/Integrations/EditSchema/EmailSettings/EmailSchemaSettings";
import { createAlert } from "@/features/homepage/alertSliceList";

const EmailSchemaSetup = () => {
  const selectedConnection = useSelector(selectSelectedConnection);
  const [selectedArtifact, setSelectedArtifact] = useState(-1);
  const [allArtifacts, setAllArtifacts] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    GetSources();
  }, []);

  const GetSources = () => {
    axios
      .get("/connectionartifactschema/email-artifacts", {
        params: {
          connectionId: selectedConnection.id,
        },
      })
      .then((response) => {
        setAllArtifacts(
          response.data?.map((x) => {
            return { key: x.ArtifactType, label: x.ArtifactName };
          }),
        );
      })
      .catch((err) => {
        console.error(err.Message);
        dispatch(
          createAlert({
            status: "Error",
            message: "Error fetching options: " + err.Message,
          }),
        );
      });
  };

  const onSelectedArtifactChange = (event) => {
    const type = event.target.value;
    if (type === "dropdown-action") return;
    setSelectedArtifact(type);
  };

  return (
    <>
      <Card>
        <Box
          sx={{
            margin: "30px 0px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subheading1">Artifact Mapping</Typography>
          <Dropdown
            width={300}
            //label="Content Source"
            onChange={onSelectedArtifactChange}
            value={selectedArtifact}
            options={allArtifacts}
            multiple={false}
          ></Dropdown>
        </Box>
      </Card>
      {selectedArtifact > 0 && (
        <EmailSchemaSettings isGlobal={false} artifactType={selectedArtifact} />
      )}
    </>
  );
};

export default EmailSchemaSetup;
